export const getTitle = (title: any) => {
  if (typeof title === "string") return title;
  return title?.translations?.en;
};

const resolveOptionName = (opt: any, menuItem: any): string => {
  if (menuItem?.name) {
    const fromMenu = getTitle(menuItem.name);
    if (fromMenu) return fromMenu;
  }
  if (opt?.name) {
    const fromOpt = getTitle(opt.name);
    if (fromOpt) return fromOpt;
  }
  return "Option";
};

export const getCustomizationDisplay = (item: any, menusData?: any) => {
  if (!item.customizations || item.customizations.length === 0) return [];

  const allItems =
    menusData?.menus?.flatMap(
      (m: any) => m.sections?.flatMap((s: any) => s.items || []) || [],
    ) || [];

  return item.customizations
    .flatMap((cus: any) => {
      if (cus.items && Array.isArray(cus.items)) {
        return cus.items.map((opt: any) => {
          const menuItem = allItems.find((i: any) => i.itemId === opt.itemId);
          return resolveOptionName(opt, menuItem);
        });
      }

      if (cus.customizationOptions && Array.isArray(cus.customizationOptions)) {
        return cus.customizationOptions.map((opt: any) => {
          const menuItem = allItems.find(
            (i: any) => i.itemId === opt.itemId && i.itemId !== opt.customizationOptionId,
          );
          return resolveOptionName(opt, menuItem);
        });
      }

      return [];
    })
    .filter(Boolean);
};

export const getSectionImage = (section: any): string =>
  section?.image?.image || section?.image?.originalImage || "";

export const readStoredList = (storage: Storage, key: string): any[] => {
  try {
    const parsed = JSON.parse(storage.getItem(key) || "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};
